import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=8242f8a6&scoped=true&"
import script from "./TreeView.vue?vue&type=script&lang=ts&"
export * from "./TreeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8242f8a6",
  null
  
)

export default component.exports